import React from 'react';
import MaterialGrid, { GridProps } from '@mui/material/Grid';
import { ThemeProvider, useTheme } from '@mui/material';

// exporting Material UI Grid with a bit different API to conform to existing Grid components

export const Col = (props: Omit<GridProps, 'item' | 'container'>): JSX.Element => <MaterialGrid {...props} item container={undefined} />;

export const Row = (props: Omit<GridProps, 'item' | 'container'>): JSX.Element => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <MaterialGrid {...props} container item={undefined} />
    </ThemeProvider>
  );
};
